import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import { injectIntl } from 'react-intl';
import Modal from '@material-ui/core/Modal';
import styles from './adgmModal-jss';

function ADGMModal(props) {
  const { classes, className, open, toggleModal, children, ...otherProps } = props;

  return (
    <>
      <Modal
        aria-labelledby='adgm-modal-title'
        aria-describedby='adgm-modal-description'
        open={open}
        onClose={toggleModal}
        disableScrollLock
        {...otherProps}
      >
        <div className={classNames(classes.modal, classes.paper, className)}>{children}</div>
      </Modal>
    </>
  );
}

ADGMModal.propTypes = {
  classes: PropTypes.object.isRequired,
  open: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func,
  children: PropTypes.node.isRequired,
  className: PropTypes.object,
};

ADGMModal.defaultProps = {
  toggleModal: null,
  className: null,
};

export default withStyles(styles)(injectIntl(ADGMModal));
